export { default as Configs } from "./pages/configs/index.jsx";
export { default as CompanyInfo } from "./pages/companyInfo/index.jsx";
